import { render, staticRenderFns } from "./OpendataChecklistForm.vue?vue&type=template&id=06231311&"
import script from "./OpendataChecklistForm.vue?vue&type=script&lang=js&"
export * from "./OpendataChecklistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports